import { createFeatureSelector, createSelector } from "@ngrx/store";
import { OrganisationListState } from "./organisation-list.reducer";

const selectOrganisationList = createFeatureSelector<OrganisationListState>("organisationList");

export const organisationList = createSelector(selectOrganisationList, state => {
    return state.organisationlist;
});